export default __webpack_public_path__ + "locales/ro/DeleteDialog.json?hash=af98bb7c75d854d171fecddff044a598";